// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/location_on_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bitcount+Prop+Single:wght@100..900&family=DM+Serif+Text:ital@0;1&family=Eagle+Lake&family=Oxygen:wght@300;400;700&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&family=Roboto+Mono:ital,wght@0,100..700;1,100..700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-blue: #0A174E;
  --main-yellow: #F5D042;
  
  --neutral-offwhite: #F4F4F4;
  --neutral-lightgray: #D9D9D9;
  --neutral-darkgray: #333333;
  
  --tertiary-light-yellow: #FBE596;
  --tertiary-light-blue: #2B3A7A;

  --main-font: "Oxygen", sans-serif;
}

body{
  box-sizing: border-box;
  display: flex;
  gap: 2vw;
  font-family: var(--main-font);
  background: var(--main-blue);
  overflow-x: hidden;
  margin: 0px;
  padding: 0px;
  user-select: none;
}

aside.current-conditions {
  background-color: var(--tertiary-light-blue);
  color: var(--neutral-lightgray);
  border-radius: 0px 5% 5% 0px;
  padding: 0px 1rem 0px 1rem;
  flex: 1 0 18vw;
  height: 100vh;
  position: relative;
  bottom: 0px;
  left: 0px;
  top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

aside.current-conditions > img {
  width: 20vw;
  height: 30vh;
  scale: 1.2;
  align-self: flex-end;
}

aside.current-conditions > h1{
  font-size: 2.5rem;
  margin-left: 1rem;
}

aside.current-conditions > h2 {
  font-size: 2rem;
}

aside.current-conditions > h2{
  color: var(--main-yellow);
}

main{
  flex: 2 0 80vw;
  margin-top: 3vh;
  display: flex;
  flex-direction: column;
}

section.navBar {
  background: var(--main-yellow);
  padding: 2rem;
  border-radius: 40px;
  width: 85%;
  border: none;
  box-shadow: inset 0px 0px 5px var(--main-blue);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

section.navBar:has(form input[type='search']:focus){
  box-shadow: 0px 20px 10px rgba(32, 32, 32, 0.44);
}

section.navBar form{
  display: flex;
  gap: 1vw;
  flex: 2 0 80%;
}

section.navBar form input[type='search'] {
  background: var(--main-blue);
  color: var(--main-yellow);
  border: none;
  padding: 0.5rem;
  border-radius: 40px;
  width: 40%;
}

section.navBar form input[type='search']:focus{
  outline: solid 1px var(--neutral-lightgray);
}
section.navBar form input[type='search']::-webkit-search-cancel-button{
  -webkit-appearance: none;
  appearance: none;
}
section.navBar form input[type='search']::placeholder{
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  top: 10%;
  opacity: 0.5;
  font-size: 16px;
  }

section.navBar form img{
  cursor: pointer;
  transition: transform .3s ease , scale .2s ease;
}

section.navBar form img:hover{
  transform: rotate(45deg);
}

section.navBar form img:active{
  scale: 1.3;
}

.unit-switch {
  display: flex;
  align-items: center;
  position: relative;
  width: 80px;
  height: auto;
}

.unit-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.unit-switch label {
  position: relative;
  display: block;
  width: 100%;
  height: 40px;
  background-color: var(--tertiary-light-blue);
  border-radius: 50px;
  cursor: pointer;
  user-select: none;
  box-shadow: inset 0 0 5px var(--main-blue);
  transition: background-color 0.3s ease;
}

.unit-switch label .unit-C,
.unit-switch label .unit-F {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-weight: bold;
  z-index: 2;
  width: 50%;
  text-align: center;
  pointer-events: none;
  color: var(--main-blue);
}
.unit-switch label .unit-F{
  color: var(--neutral-offwhite);
}

.unit-switch label .unit-C {
  left: 0;
}

.unit-switch label .unit-F {
  right: 0;
}

.unit-switch label .slider {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 34px;
  height: 34px;
  background-color: var(--tertiary-light-yellow);
  border-radius: 50px;
  transition: 0.3s;
}

/* Toggle when checked */
.unit-switch input:checked + label .slider {
  transform: translateX(32px);
  background-color: var(--tertiary-light-yellow);
}

.unit-switch input:checked + label .unit-C {
  color: var(--neutral-offwhite);
}

.unit-switch input:checked + label .unit-F {
  color: var(--main-blue);
}


.next-seven-days,
.extra-info{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.next-seven-days > h2,
.extra-info > h2{
  color: var(--main-yellow);
}

.forecasts{
  display: flex;
  flex-wrap: wrap;
  gap: 1vw;
}

.day-mini-forecast{
  width: calc(60vw/7);
  height: 25vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5%;
  align-items: center;
  background: var(--tertiary-light-blue);
  border-radius: 50px;
  padding: 0.3rem;
  cursor: pointer;
  transition: transform .2s ease-in;
}
.day-mini-forecast:hover{
  transform: translateY(-10%);
}
.day-mini-forecast h3,
.day-mini-forecast span{
  color: var(--main-yellow);
}
.day-mini-forecast img{
  object-fit: cover;
  width: 40%;
  height: 30%;
}

.info-box-container{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1vw;
}

.info-box{
  background-color: var(--main-yellow);
  border-radius: 50px;
  padding: 0px 1.5rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 20vw;
}

.info-box h3 span{
  align-self: flex-start;
  font-size: 2rem;
  color: var(--neutral-darkgray);
}

.info-box > span{
  margin-right: 1rem;
  font-size: 1.4rem;
}

.info-box h3 img {
  scale: 1.4;
  margin-left: 0.5vw;
}

.info-box span{
  align-self: flex-end;
  font-size: 1.5rem;
  color: var(--tertiary-light-blue);
}

.loader {
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  position: fixed;
  left: 50%;
  bottom: 45%;
  background: 
    radial-gradient(farthest-side,#ffa516 94%,#0000) top/8px 8px no-repeat,
    conic-gradient(#0000 30%,#ffa516);
  
  mask: radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0);
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: cover;

  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0);

  animation: l13 1s infinite linear;
}

@keyframes l13 { 
  100% { transform: rotate(1turn); }
}


/* Small tablets / large phones */
@media (max-width: 1024px) {

  .loader{
    left: 45%;
  }
  body {
    flex-direction: column;
    gap: 1rem;
  }

  aside.current-conditions {
    width: 100%;
    flex: none;
    border-radius: 0 0 20px 20px;
    height: auto;
    padding: 1rem;
  }

  aside.current-conditions > img {
    width: 40vw;
    height: auto;
    align-self: center;
    scale: 1;
  }

  main {
    width: 100%;
    margin-top: 1rem;
  }

  section.navBar {
    flex-direction: row;
    gap: 1rem;
    width: 80%;
    padding: 1rem;
    margin: auto;
    margin-bottom: 2rem;
  }

  section.navBar form input[type='search'] {
    width: 60%;
  }

  .next-seven-days h2,
  .extra-info h2{
    margin-bottom: 5vh;
    font-size: 3rem;
    margin-left: 1rem;
  }

  .forecasts {
    gap: 1.5rem;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    margin-left: 1rem;
  }

  .day-mini-forecast {
    width: 25%;
    height: 20vh;
  }
  
  .extra-info{
    width: 100%;
    margin-left: 1rem;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .info-box-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .info-box {
    width: 40%;
    padding: 1rem
  }
}

/* For Phones */
@media (max-width: 600px) {
  body {
    gap: 0.5rem;
  }

  aside.current-conditions {
    padding: 0.5rem;
    text-align: center;
  }

  aside.current-conditions > h1 {
    font-size: 2rem;
  }

  aside.current-conditions > h2 {
    font-size: 1.5rem;
  }

  aside.current-conditions > img {
    width: 60vw;
    height: auto;
  }

  section.navBar {
    width: 80%;
    padding: 1rem;
  }

  section.navBar form {
    flex-direction: row;
    gap: 0.5rem;
    width: 100%;
  }

  section.navBar form input[type='search'] {
    width: 60%;
    font-size: 1rem;
  }

  .unit-switch {
    display: flex;
    align-items: center;
    position: relative;
    width: 90px;
    height: auto;
  }

  .unit-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .unit-switch label {
    position: relative;
    right: 40%;
    display: block;
    width: 20vw;
    height: 40px;
    background-color: var(--tertiary-light-blue);
    border-radius: 50px;
    cursor: pointer;
    user-select: none;
    box-shadow: inset 0 0 5px var(--main-blue);
    transition: background-color 0.3s ease;
  }

  .unit-switch label .unit-C,
  .unit-switch label .unit-F {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-weight: bold;
    z-index: 2;
    width: 50%;
    text-align: center;
    pointer-events: none;
    color: var(--main-blue);
  }
  .unit-switch label .unit-F{
    color: var(--neutral-offwhite);
  }

  .unit-switch label .unit-C {
    left: 0;
  }

  .unit-switch label .unit-F {
    right: 0;
  }

  .unit-switch label .slider {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 34px;
    height: 34px;
    background-color: var(--tertiary-light-yellow);
    border-radius: 50px;
    transition: 0.3s;
  }

  /* Toggle when checked */
  .unit-switch input:checked + label .slider {
    transform: translateX(32px);
    background-color: var(--tertiary-light-yellow);
  }

  .unit-switch input:checked + label .unit-C {
    color: var(--neutral-offwhite);
  }

  .unit-switch input:checked + label .unit-F {
    color: var(--main-blue);
  }

  .next-seven-days{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
  }

  .day-mini-forecast {
    width: 70%;
    height: 15vh;
    margin: auto;
    padding-bottom: 10%;
  }
  .day-mini-forecast:hover{
    transform: translateY(-5%);
  }
  .day-mini-forecast img{
    width: 30%;
    height: 30%;
  }

  .forecasts {
    gap: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
  }

  .info-box-container {
    gap: 0.5rem;
    margin-left: -1rem;
    margin-bottom: 2rem;
  }

  .info-box h3 {
    font-size: 1.5rem;
  }

  .info-box span {
    font-size: 1rem;
  }
}

@media (min-width: 361px) and (max-width: 500px) {
  .unit-switch input:checked + label .slider{
    transform: translateX(40px);
  }

  .info-box-container {
    gap: 0.5rem;
    margin-right: 1.2rem;
    margin-left: -0.5rem;
  }

  .info-box h3 span{
    scale: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,sBAAsB;;EAEtB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;;EAE3B,gCAAgC;EAChC,8BAA8B;;EAE9B,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,2CAA2C;AAC7C;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,gDAA6E;EAC7E,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf;;AAEF;EACE,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,OAAO;EACP,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,WAAW;EACX;;qCAEmC;;EAEnC,kEAAkE;EAClE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;;EAEhB,0EAA0E;;EAE1E,iCAAiC;AACnC;;AAEA;EACE,OAAO,wBAAwB,EAAE;AACnC;;;AAGA,iCAAiC;AACjC;;EAEE;IACE,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,UAAU;IACV,4BAA4B;IAC5B,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,UAAU;IACV;EACF;AACF;;AAEA,eAAe;AACf;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,0CAA0C;IAC1C,sCAAsC;EACxC;;EAEA;;IAEE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,iBAAiB;IACjB,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,wBAAwB;EACxB;IACE,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Bitcount+Prop+Single:wght@100..900&family=DM+Serif+Text:ital@0;1&family=Eagle+Lake&family=Oxygen:wght@300;400;700&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&family=Roboto+Mono:ital,wght@0,100..700;1,100..700&display=swap');\r\n\r\n:root {\r\n  --main-blue: #0A174E;\r\n  --main-yellow: #F5D042;\r\n  \r\n  --neutral-offwhite: #F4F4F4;\r\n  --neutral-lightgray: #D9D9D9;\r\n  --neutral-darkgray: #333333;\r\n  \r\n  --tertiary-light-yellow: #FBE596;\r\n  --tertiary-light-blue: #2B3A7A;\r\n\r\n  --main-font: \"Oxygen\", sans-serif;\r\n}\r\n\r\nbody{\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  gap: 2vw;\r\n  font-family: var(--main-font);\r\n  background: var(--main-blue);\r\n  overflow-x: hidden;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  user-select: none;\r\n}\r\n\r\naside.current-conditions {\r\n  background-color: var(--tertiary-light-blue);\r\n  color: var(--neutral-lightgray);\r\n  border-radius: 0px 5% 5% 0px;\r\n  padding: 0px 1rem 0px 1rem;\r\n  flex: 1 0 18vw;\r\n  height: 100vh;\r\n  position: relative;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  top: 0px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n\r\naside.current-conditions > img {\r\n  width: 20vw;\r\n  height: 30vh;\r\n  scale: 1.2;\r\n  align-self: flex-end;\r\n}\r\n\r\naside.current-conditions > h1{\r\n  font-size: 2.5rem;\r\n  margin-left: 1rem;\r\n}\r\n\r\naside.current-conditions > h2 {\r\n  font-size: 2rem;\r\n}\r\n\r\naside.current-conditions > h2{\r\n  color: var(--main-yellow);\r\n}\r\n\r\nmain{\r\n  flex: 2 0 80vw;\r\n  margin-top: 3vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\nsection.navBar {\r\n  background: var(--main-yellow);\r\n  padding: 2rem;\r\n  border-radius: 40px;\r\n  width: 85%;\r\n  border: none;\r\n  box-shadow: inset 0px 0px 5px var(--main-blue);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\nsection.navBar:has(form input[type='search']:focus){\r\n  box-shadow: 0px 20px 10px rgba(32, 32, 32, 0.44);\r\n}\r\n\r\nsection.navBar form{\r\n  display: flex;\r\n  gap: 1vw;\r\n  flex: 2 0 80%;\r\n}\r\n\r\nsection.navBar form input[type='search'] {\r\n  background: var(--main-blue);\r\n  color: var(--main-yellow);\r\n  border: none;\r\n  padding: 0.5rem;\r\n  border-radius: 40px;\r\n  width: 40%;\r\n}\r\n\r\nsection.navBar form input[type='search']:focus{\r\n  outline: solid 1px var(--neutral-lightgray);\r\n}\r\nsection.navBar form input[type='search']::-webkit-search-cancel-button{\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n}\r\nsection.navBar form input[type='search']::placeholder{\r\n  content: url(./assets/location_on_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg);\r\n  position: absolute;\r\n  top: 10%;\r\n  opacity: 0.5;\r\n  font-size: 16px;\r\n  }\r\n\r\nsection.navBar form img{\r\n  cursor: pointer;\r\n  transition: transform .3s ease , scale .2s ease;\r\n}\r\n\r\nsection.navBar form img:hover{\r\n  transform: rotate(45deg);\r\n}\r\n\r\nsection.navBar form img:active{\r\n  scale: 1.3;\r\n}\r\n\r\n.unit-switch {\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n  width: 80px;\r\n  height: auto;\r\n}\r\n\r\n.unit-switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.unit-switch label {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  height: 40px;\r\n  background-color: var(--tertiary-light-blue);\r\n  border-radius: 50px;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  box-shadow: inset 0 0 5px var(--main-blue);\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.unit-switch label .unit-C,\r\n.unit-switch label .unit-F {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  font-weight: bold;\r\n  z-index: 2;\r\n  width: 50%;\r\n  text-align: center;\r\n  pointer-events: none;\r\n  color: var(--main-blue);\r\n}\r\n.unit-switch label .unit-F{\r\n  color: var(--neutral-offwhite);\r\n}\r\n\r\n.unit-switch label .unit-C {\r\n  left: 0;\r\n}\r\n\r\n.unit-switch label .unit-F {\r\n  right: 0;\r\n}\r\n\r\n.unit-switch label .slider {\r\n  position: absolute;\r\n  top: 3px;\r\n  left: 3px;\r\n  width: 34px;\r\n  height: 34px;\r\n  background-color: var(--tertiary-light-yellow);\r\n  border-radius: 50px;\r\n  transition: 0.3s;\r\n}\r\n\r\n/* Toggle when checked */\r\n.unit-switch input:checked + label .slider {\r\n  transform: translateX(32px);\r\n  background-color: var(--tertiary-light-yellow);\r\n}\r\n\r\n.unit-switch input:checked + label .unit-C {\r\n  color: var(--neutral-offwhite);\r\n}\r\n\r\n.unit-switch input:checked + label .unit-F {\r\n  color: var(--main-blue);\r\n}\r\n\r\n\r\n.next-seven-days,\r\n.extra-info{\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n}\r\n\r\n.next-seven-days > h2,\r\n.extra-info > h2{\r\n  color: var(--main-yellow);\r\n}\r\n\r\n.forecasts{\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1vw;\r\n}\r\n\r\n.day-mini-forecast{\r\n  width: calc(60vw/7);\r\n  height: 25vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  gap: 5%;\r\n  align-items: center;\r\n  background: var(--tertiary-light-blue);\r\n  border-radius: 50px;\r\n  padding: 0.3rem;\r\n  cursor: pointer;\r\n  transition: transform .2s ease-in;\r\n}\r\n.day-mini-forecast:hover{\r\n  transform: translateY(-10%);\r\n}\r\n.day-mini-forecast h3,\r\n.day-mini-forecast span{\r\n  color: var(--main-yellow);\r\n}\r\n.day-mini-forecast img{\r\n  object-fit: cover;\r\n  width: 40%;\r\n  height: 30%;\r\n}\r\n\r\n.info-box-container{\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 1vw;\r\n}\r\n\r\n.info-box{\r\n  background-color: var(--main-yellow);\r\n  border-radius: 50px;\r\n  padding: 0px 1.5rem 1rem 1rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  width: 20vw;\r\n}\r\n\r\n.info-box h3 span{\r\n  align-self: flex-start;\r\n  font-size: 2rem;\r\n  color: var(--neutral-darkgray);\r\n}\r\n\r\n.info-box > span{\r\n  margin-right: 1rem;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.info-box h3 img {\r\n  scale: 1.4;\r\n  margin-left: 0.5vw;\r\n}\r\n\r\n.info-box span{\r\n  align-self: flex-end;\r\n  font-size: 1.5rem;\r\n  color: var(--tertiary-light-blue);\r\n}\r\n\r\n.loader {\r\n  width: 50px;\r\n  aspect-ratio: 1;\r\n  border-radius: 50%;\r\n  position: fixed;\r\n  left: 50%;\r\n  bottom: 45%;\r\n  background: \r\n    radial-gradient(farthest-side,#ffa516 94%,#0000) top/8px 8px no-repeat,\r\n    conic-gradient(#0000 30%,#ffa516);\r\n  \r\n  mask: radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0);\r\n  mask-repeat: no-repeat;\r\n  mask-position: center;\r\n  mask-size: cover;\r\n\r\n  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0);\r\n\r\n  animation: l13 1s infinite linear;\r\n}\r\n\r\n@keyframes l13 { \r\n  100% { transform: rotate(1turn); }\r\n}\r\n\r\n\r\n/* Small tablets / large phones */\r\n@media (max-width: 1024px) {\r\n\r\n  .loader{\r\n    left: 45%;\r\n  }\r\n  body {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n  }\r\n\r\n  aside.current-conditions {\r\n    width: 100%;\r\n    flex: none;\r\n    border-radius: 0 0 20px 20px;\r\n    height: auto;\r\n    padding: 1rem;\r\n  }\r\n\r\n  aside.current-conditions > img {\r\n    width: 40vw;\r\n    height: auto;\r\n    align-self: center;\r\n    scale: 1;\r\n  }\r\n\r\n  main {\r\n    width: 100%;\r\n    margin-top: 1rem;\r\n  }\r\n\r\n  section.navBar {\r\n    flex-direction: row;\r\n    gap: 1rem;\r\n    width: 80%;\r\n    padding: 1rem;\r\n    margin: auto;\r\n    margin-bottom: 2rem;\r\n  }\r\n\r\n  section.navBar form input[type='search'] {\r\n    width: 60%;\r\n  }\r\n\r\n  .next-seven-days h2,\r\n  .extra-info h2{\r\n    margin-bottom: 5vh;\r\n    font-size: 3rem;\r\n    margin-left: 1rem;\r\n  }\r\n\r\n  .forecasts {\r\n    gap: 1.5rem;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    width: 100%;\r\n    margin-left: 1rem;\r\n  }\r\n\r\n  .day-mini-forecast {\r\n    width: 25%;\r\n    height: 20vh;\r\n  }\r\n  \r\n  .extra-info{\r\n    width: 100%;\r\n    margin-left: 1rem;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .info-box-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .info-box {\r\n    width: 40%;\r\n    padding: 1rem\r\n  }\r\n}\r\n\r\n/* For Phones */\r\n@media (max-width: 600px) {\r\n  body {\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  aside.current-conditions {\r\n    padding: 0.5rem;\r\n    text-align: center;\r\n  }\r\n\r\n  aside.current-conditions > h1 {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  aside.current-conditions > h2 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  aside.current-conditions > img {\r\n    width: 60vw;\r\n    height: auto;\r\n  }\r\n\r\n  section.navBar {\r\n    width: 80%;\r\n    padding: 1rem;\r\n  }\r\n\r\n  section.navBar form {\r\n    flex-direction: row;\r\n    gap: 0.5rem;\r\n    width: 100%;\r\n  }\r\n\r\n  section.navBar form input[type='search'] {\r\n    width: 60%;\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .unit-switch {\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n    width: 90px;\r\n    height: auto;\r\n  }\r\n\r\n  .unit-switch input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n  }\r\n\r\n  .unit-switch label {\r\n    position: relative;\r\n    right: 40%;\r\n    display: block;\r\n    width: 20vw;\r\n    height: 40px;\r\n    background-color: var(--tertiary-light-blue);\r\n    border-radius: 50px;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    box-shadow: inset 0 0 5px var(--main-blue);\r\n    transition: background-color 0.3s ease;\r\n  }\r\n\r\n  .unit-switch label .unit-C,\r\n  .unit-switch label .unit-F {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    font-weight: bold;\r\n    z-index: 2;\r\n    width: 50%;\r\n    text-align: center;\r\n    pointer-events: none;\r\n    color: var(--main-blue);\r\n  }\r\n  .unit-switch label .unit-F{\r\n    color: var(--neutral-offwhite);\r\n  }\r\n\r\n  .unit-switch label .unit-C {\r\n    left: 0;\r\n  }\r\n\r\n  .unit-switch label .unit-F {\r\n    right: 0;\r\n  }\r\n\r\n  .unit-switch label .slider {\r\n    position: absolute;\r\n    top: 3px;\r\n    left: 3px;\r\n    width: 34px;\r\n    height: 34px;\r\n    background-color: var(--tertiary-light-yellow);\r\n    border-radius: 50px;\r\n    transition: 0.3s;\r\n  }\r\n\r\n  /* Toggle when checked */\r\n  .unit-switch input:checked + label .slider {\r\n    transform: translateX(32px);\r\n    background-color: var(--tertiary-light-yellow);\r\n  }\r\n\r\n  .unit-switch input:checked + label .unit-C {\r\n    color: var(--neutral-offwhite);\r\n  }\r\n\r\n  .unit-switch input:checked + label .unit-F {\r\n    color: var(--main-blue);\r\n  }\r\n\r\n  .next-seven-days{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: auto;\r\n  }\r\n\r\n  .day-mini-forecast {\r\n    width: 70%;\r\n    height: 15vh;\r\n    margin: auto;\r\n    padding-bottom: 10%;\r\n  }\r\n  .day-mini-forecast:hover{\r\n    transform: translateY(-5%);\r\n  }\r\n  .day-mini-forecast img{\r\n    width: 30%;\r\n    height: 30%;\r\n  }\r\n\r\n  .forecasts {\r\n    gap: 0.5rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: auto;\r\n  }\r\n\r\n  .info-box-container {\r\n    gap: 0.5rem;\r\n    margin-left: -1rem;\r\n    margin-bottom: 2rem;\r\n  }\r\n\r\n  .info-box h3 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .info-box span {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 361px) and (max-width: 500px) {\r\n  .unit-switch input:checked + label .slider{\r\n    transform: translateX(40px);\r\n  }\r\n\r\n  .info-box-container {\r\n    gap: 0.5rem;\r\n    margin-right: 1.2rem;\r\n    margin-left: -0.5rem;\r\n  }\r\n\r\n  .info-box h3 span{\r\n    scale: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
